import state from "./state";

let initialState = state;

export default (state = initialState) => {
  return state;
};



// WEBPACK FOOTER //
// ./src/store/modules/dailypass/reducers.js